import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';

import { loadVacancyRejectionReasonsDetails } from '../../../../../store/directusService';
import { reverseFormatDate } from '../../../../../utils/dateFunctions';
import { getNameFromId } from '../../../../../utils/directusFunctions';
import { VACANCY_REJECTION_REASONS_DETAILS_ERROR } from '../../../../../utils/formValidation/loadingErrorMessageConstants';
import TextAreaField from '../../../../formElements/TextAreaField';
import TextInputField from '../../../../formElements/TextInputField';
import LoadingSpinner from '../../../../ui/LoadingSpinner';

import app from '../../../../../app.module.css';
import dropdownClasses from '../../../../courses/courseStyles/rowDropDown.module.css';

const RejectedVacancyDetails = ({ row, onClose }) => {
    // HOOKS
    const dispatch = useDispatch();

    // LOCAL STATE
    const [reasonNames, setReasonNames] = useState([]);

    // STORE STATE
    const vacancyRejectionReasonsDetails = useSelector(
        (state) => state.entities.directusService.vacancyRejectionReasonsDetails
    );

    // USE EFFECTS
    useEffect(() => {
        vacancyRejectionReasonsDetails?.length < 1 &&
            dispatch(loadVacancyRejectionReasonsDetails());
    }, []);

    useEffect(() => {
        if (vacancyRejectionReasonsDetails?.length < 1) return;

        if (!row.rejectionReasonIds) return;

        setReasonNames(
            row.rejectionReasonIds.map((el) => getNameFromId(vacancyRejectionReasonsDetails, el))
        );
    }, [vacancyRejectionReasonsDetails]);

    // HELPER FNS
    const loadingError = () => {
        if (vacancyRejectionReasonsDetails?.length < 1)
            return VACANCY_REJECTION_REASONS_DETAILS_ERROR;
    };

    // AWAITING CONTENT
    const errorMsg = loadingError();
    if (errorMsg) return <LoadingSpinner content={errorMsg} time={3} />;

    // RENDER
    return (
        <div className={dropdownClasses.rowDropdown}>
            <form data-testid="form_start">
                <h2 className={app.sectionHeading}>Rejection Details:</h2>
                <TextInputField
                    id={'rejectionDate'}
                    label={'Date of rejection'}
                    disabled={true}
                    value={reverseFormatDate(row.rejectionDate) || ''}
                />
                <TextInputField
                    id={'rejectionReasons'}
                    label={'Rejection Reasons'}
                    disabled={true}
                    value={reasonNames.join(', ')}
                />
                <TextAreaField
                    id={'feedback'}
                    label={'Feedback'}
                    disabled={true}
                    rows={3}
                    value={row.feedback || ''}
                />
                <div className={dropdownClasses.exit} onClick={onClose}>
                    Close details
                    <CloseIcon />
                </div>
            </form>
        </div>
    );
};

RejectedVacancyDetails.propTypes = {
    row: PropTypes.object,
    onClose: PropTypes.func.isRequired
};

export default RejectedVacancyDetails;
